import { render } from "./Income.vue?vue&type=template&id=0ce16773&scoped=true"
import script from "./Income.vue?vue&type=script&lang=js"
export * from "./Income.vue?vue&type=script&lang=js"

import "./Income.vue?vue&type=style&index=0&id=0ce16773&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0ce16773"

export default script